document.addEventListener("DOMContentLoaded", () => {
  const carousel = document.getElementById("reviewCarousel");
  const dots = document.querySelectorAll(".dot");
  if (dots && dots.length > 0) {
    dots[0].classList.add("active");
    carousel.addEventListener("slid.bs.carousel", (event) => {
      const activeIndex = event.to;
      dots.forEach((dot) => dot.classList.remove("active"));
      dots[activeIndex].classList.add("active");
    });
    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        const carouselInstance = bootstrap.Carousel.getInstance(carousel);
        carouselInstance.to(index);
      });
    });
  }

  // Animations

  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.5,
  };

  function intersectionCallback(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (entry.target.classList.contains("fade-up")) {
          entry.target.classList.add("animated", "fadeInUp");
        } else if (entry.target.classList.contains("fade-left")) {
          entry.target.classList.add("animated", "fadeInLeft");
        } else if (entry.target.classList.contains("fade-right")) {
          entry.target.classList.add("animated", "fadeInRight");
        } else if (entry.target.classList.contains("fade-down")) {
          entry.target.classList.add("animated", "fadeInDown");
        }
        observer.unobserve(entry.target);
      }
    });
  }

  const observer = new IntersectionObserver(intersectionCallback, observerOptions);
  function observeElements() {
    const elements = document.querySelectorAll(".animate-in");
    elements.forEach((el) => observer.observe(el));
  }
  observeElements();
});
